module.exports = __webpack_public_path__ + "assets/loop-delete-grid.9fcace52.svg";